import UploadStatusModal from "./container";

export default UploadStatusModal;